import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class JsonDateInterceptor implements HttpInterceptor {
  private readonly _isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((val: HttpEvent<unknown>) => {
        if (val instanceof HttpResponse) {
          const body = val.body as Record<string, unknown> | null;
          this.convert(body);
        }
        return val;
      }),
    );
  }
  isIsoDateString(value: unknown): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      return this._isoDateFormat.test(value);
    }
    return false;
  }
  private readonly _zurichFmt = new Intl.DateTimeFormat(undefined, {
    timeZone: 'Europe/Zurich',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  convert(body: Record<string, unknown> | null | undefined): void {
    if (body === null || body === undefined) {
      return;
    }
    if (typeof body !== 'object') {
      return;
    }
    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIsoDateString(value)) {
        // All dates from the backend are stored in Europe/Zurich.
        // Re-express the UTC instant as a Zurich wall-clock time and store it as a
        // timezone-neutral local Date, so it displays identically in every viewer's timezone.
        const p = Object.fromEntries(
          this._zurichFmt.formatToParts(new Date(value as string)).map((x) => [x.type, x.value]),
        );
        // Year must be zero-padded to at least 4 digits for a valid ISO 8601 string.
        // formatToParts returns e.g. '199' for year 199 AD, which new Date() rejects.
        const year = p['year'].padStart(4, '0');
        body[key] = new Date(`${year}-${p['month']}-${p['day']}T${p['hour']}:${p['minute']}:${p['second']}`);
      } else if (typeof value === 'object') {
        this.convert(value as Record<string, unknown>);
      }
    }
  }
}
